import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_621 implements Validator {

    public static id = 'CTRL_621';
    private message = 'error.ctr_621';


    public LOG: LogService = new LogService(CTRL_621);
    public formExtractorService: FormExtractorService = new FormExtractorService();


    validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_621.id + '_');


        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const dateFinDiffusionWithStepId = map.get(ctrl.value.rgCtrls.date);
                const dateFinDiffusionCtrl = form.controls[dateFinDiffusionWithStepId];
                
                if (!dateFinDiffusionCtrl.value || dateFinDiffusionCtrl.value === '') {
                    continue;
                }

                const dateFin = new Date(dateFinDiffusionCtrl.value);
                const dateLimite = new Date();
                dateLimite.setDate(dateLimite.getDate() + 10);
                dateFin.setHours(0, 0, 0, 0);
                dateLimite.setHours(0, 0, 0, 0);

                if (dateFin.getTime() > dateLimite.getTime()) {
                    // Date strictement supérieure : validation OK
                    form.controls[rg].value = { 
                        rgCtrls: ctrl.value.rgCtrls, 
                        ctrlValidation: false 
                    };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { 
                        rgCtrls: ctrl.value.rgCtrls, 
                        ctrlValidation: true, 
                        validation_message: this.message 
                    };
                }
            }
        }
    }
}